import styled from 'styled-components'

export const AlertContainer = styled.div`
  background: #f7d4d4;
  border-radius: 6px;
  padding: 12px 16px;
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 24px;
`

export const AlertContent = styled.div`
  display: flex;
  flex: 1;
  gap: 12px;
  align-items: flex-start;
`

export const IconWrapper = styled.div`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  height: 24px;

  svg {
    width: 20px;
    height: 20px;
  }
`

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`

export const AlertTitle = styled.p`
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  color: #262626;
  margin: 0;
`

export const AlertDescription = styled.p`
  font-family: 'Inter', sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #262626;
  margin: 0;

  a {
    color: #ad1f22;
    text-decoration: underline;
    cursor: pointer;

    &:hover {
      text-decoration: none;
    }
  }
`

export const CloseButton = styled.button`
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  padding: 0;
  transition: background-color 0.2s ease;

  &:hover {
    background: rgba(173, 31, 34, 0.1);
  }

  &:focus {
    outline: 2px solid #ad1f22;
    outline-offset: 2px;
  }
`

export const CloseIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 25px;
  height: 25px;

  svg {
    width: 20px;
    height: 20px;
  }
`
